/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchFollowingPressReleaseResponseData,
    SearchFollowingPressReleaseResponseDataFromJSON,
    SearchFollowingPressReleaseResponseDataFromJSONTyped,
    SearchFollowingPressReleaseResponseDataToJSON,
} from './SearchFollowingPressReleaseResponseData';

/**
 * 
 * @export
 * @interface SearchLatestPressReleasesByBusinessCategoryLv2IdResponse
 */
export interface SearchLatestPressReleasesByBusinessCategoryLv2IdResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdResponse
     */
    message: string;
    /**
     * 
     * @type {SearchFollowingPressReleaseResponseData}
     * @memberof SearchLatestPressReleasesByBusinessCategoryLv2IdResponse
     */
    data: SearchFollowingPressReleaseResponseData;
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdResponseFromJSON(json: any): SearchLatestPressReleasesByBusinessCategoryLv2IdResponse {
    return SearchLatestPressReleasesByBusinessCategoryLv2IdResponseFromJSONTyped(json, false);
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLatestPressReleasesByBusinessCategoryLv2IdResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchFollowingPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function SearchLatestPressReleasesByBusinessCategoryLv2IdResponseToJSON(value?: SearchLatestPressReleasesByBusinessCategoryLv2IdResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchFollowingPressReleaseResponseDataToJSON(value.data),
    };
}

